import { FF_UMG_BLOCKED_ANY_LLM_MODELS } from '@/consts/featureFlags';
import { posthog } from '@/providers/posthog';

const getBlockedAnyLlmModelSubstrings = (): string[] => {
  if (!posthog.isFeatureEnabled(FF_UMG_BLOCKED_ANY_LLM_MODELS)) {
    return [];
  }

  const payload = posthog.getFeatureFlagResult(FF_UMG_BLOCKED_ANY_LLM_MODELS)?.payload;
  if (!Array.isArray(payload)) {
    return [];
  }

  return payload.filter((value): value is string => typeof value === 'string' && value.trim().length > 0);
};

export const shouldBlockAnyLlmModelIfNeeded = (model: string): boolean => {
  const blockedSubstrings = getBlockedAnyLlmModelSubstrings();
  return blockedSubstrings.some((blockedSubstring) => model.includes(blockedSubstring));
};

export const removeBlockedAnyLlmModelsIfNeeded = (models: string[]) => {
  const blockedSubstrings = getBlockedAnyLlmModelSubstrings();
  if (blockedSubstrings.length > 0 && models?.length > 0) {
    return models.filter((model) => !blockedSubstrings.some((blockedSubstring) => model.includes(blockedSubstring)));
  }
  return models;
};
